export default __webpack_public_path__ + "static/media/avatar-normal-geometric-16.6f22cb62.svg";